var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_176)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_381_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4794 8.00469H2.77839L11.2638 1.17619C11.4669 1.01272 11.4669 0.746995 11.2638 0.583534C11.0607 0.420072 10.7305 0.420072 10.5273 0.583534L1.15234 8.12791C1.10443 8.16563 1.06589 8.21258 1.03984 8.26371C0.986719 8.36598 0.986719 8.48166 1.03984 8.58393C1.06589 8.63506 1.10443 8.682 1.15234 8.72056L10.5273 16.2649C10.6294 16.3463 10.7628 16.3873 10.8961 16.3873C11.0294 16.3873 11.1628 16.3463 11.2648 16.2649C11.468 16.1015 11.468 15.8357 11.2648 15.6723L2.77839 8.84295H25.4794C25.7669 8.84295 26.0003 8.65518 26.0003 8.42382C26.0003 8.19246 25.7669 8.00469 25.4794 8.00469Z",
    fill: "#305569"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 16.0947,
    fill: "white",
    transform: "translate(0 0.460938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_381_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 15.927,
    fill: "white",
    transform: "translate(1 0.460938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e2daf9f7ea4beae0b62302395deeb26e.svg";
export { ForwardRef as ReactComponent };